import { Layout, MTools } from '@/components';
import React, { useEffect, useState } from 'react';
import styles from './index.less';
import { getBoothList } from '@/services/api';
import { IBooth } from '@/models/types/booth';

interface ICompanyProps {

}

const Company: React.FC<ICompanyProps> = (props) => {
  const [list, setList] = useState<IBooth[]>([])

  useEffect(() => {
    getListData();
  }, [])

  const getListData = async () => {
    const result = await getBoothList()
    if (result.success) {
      if (result.data.length) {
        setList(result.data.filter((item: any) => item.showPosition === 1 || item.showPosition === 3))
      }
    } else {
      MTools.Tips('error', (result && (result.message)) || '系统异常，请刷新再试')
    }
  }

  return (
    <div className={styles.index}>
      <Layout
        padding={0}
      >
        <div className={styles.list}>
          {
            list.map(item => {
              return (
                <div
                  key={item.id}
                  className={styles.item}
                  onClick={
                    () => {
                      if (item.showDetail === 1) {
                        MTools.Url.gotoUrl(`/app/company/${item.id}`)
                      }
                    }}
                >
                  <div className={styles.logo}>
                    <div
                      className={styles.logoInner}
                      style={{ backgroundImage: `url(${item.logo || item.cover})` }}
                    ></div>
                  </div>

                  <div className={styles.title}>{item.title}</div>
                </div>
              )
            })
          }
        </div>
      </Layout>
    </div>
  );
};

export default Company;
